import { defineMessages } from 'react-intl';

const trns = defineMessages({
  commentsTitle: {
    id: 'XWfm/Q',
    defaultMessage: 'Відгуки наших користувачів'
  },
  showMoreTitle: {
    id: 'vkL/zB',
    defaultMessage: 'Розгорнути'
  },
  showLessTitle: {
    id: 'f/WfD8',
    defaultMessage: 'Згорнути'
  },
  comment1: {
    id: 'arvzRE',
    defaultMessage:
      'Сервіс новий, можливо чомусь поки що недосконалий, але набагато зручніший за більшість існуючих сайтів. Авторам побажання швидше завершити всі доробки і підкорити фармасвіт.'
  },
  comment2: {
    id: 'iBmm6C',
    defaultMessage:
      'Сайт створений для таких, як я. Маючи хворих батьків, пошук і купівля ліків - це те ще випробування. Але тут зручний пошук і не доводиться витрачати багато часу, навіть коли я не можу згадати точної назви.'
  },
  comment3: {
    id: 'hkyn9l',
    defaultMessage:
      'Для мене, як для волонтера, час і гроші - то питання життя і смерті, бо кожна копійка на рахунку, а швидкість - то інколи чиєсь життя. Дуже допомагає, коли є такий сервіс. Легко знайти все потрібне, легко зібрати замовлення на більш ніж 30 найменувань, легко все одним махом забронювати.'
  }
});

export default trns;
